export default {
  toasts: {
    load_error: 'Nie udało się załadować faktur.',
    action_error: 'Akcja nie powiodła się — spróbuj ponownie.',
    finalized: 'Faktura sfinalizowana.',
    marked_paid: 'Faktura oznaczona jako opłacona.',
  },
  filters: {
    status: 'Filtruj według statusu',
  },
  volume_discount_badge: 'Zastosowano rabat wolumenowy ({{licenses}} licencji, {{percent}}%)',
  columns: {
    description: 'Faktura',
    status: 'Status',
    total: 'Suma',
    paid_at: 'Zapłacono',
  },
  statuses: {
    pending: 'Oczekująca',
    processing: 'W trakcie',
    paid: 'Opłacona',
    failed: 'Nieudana',
    refunded: 'Zwrócona',
    partially_refunded: 'Częściowo zwrócona',
  },
  companies: {
    partner_level: 'Korekty na poziomie partnera',
    columns: {
      company: 'Restauracja',
      buckets: 'Pozycje',
      amount: 'Kwota',
    },
  },
  buckets: {
    license_fees: 'Opłaty licencyjne',
    service_fees: 'Opłaty serwisowe',
    processing_fees: 'Opłaty za przetwarzanie',
    delivery_fees: 'Opłaty za dostawę',
    gift_card_fees: 'Opłaty za karty podarunkowe',
    adjustments: 'Korekty',
  },
  entries: {
    count: '{{count}} wpisów',
    columns: {
      description: 'Wpis',
      occurred_at: 'Data',
      amount: 'Kwota',
    },
  },
  incl_tax: 'w tym {{amount}} VAT',
  actions: {
    open_invoice_pdf: 'Pobierz fakturę (PDF)',
    open_hosted: 'Otwórz fakturę na Stripe',
    export_csv: 'Eksportuj CSV',
    finalize: 'Sfinalizuj na Stripe',
    mark_paid: 'Oznacz jako opłaconą',
  },
  finalize: {
    title: 'Sfinalizować tę fakturę na Stripe?',
    description:
      'Finalizacja uruchamia pobieranie: przy zapisanej metodzie płatności opłata jest automatyczna, w przeciwnym razie partner otrzymuje hostowaną fakturę.',
    confirm: 'Sfinalizuj',
  },
  mark_paid: {
    pushed_note:
      'Ta faktura jest już na Stripe — szkic zostanie usunięty (lub sfinalizowana faktura oznaczona jako opłacona poza systemem), aby Stripe zaprzestał pobierania.',
    title: 'Oznaczyć tę fakturę jako opłaconą?',
    description:
      'Rejestruje ręczną (offline) płatność w wysokości {{amount}}. Użyj dla przelewów bankowych poza Stripe.',
    confirm: 'Oznacz jako opłaconą',
  },
  settlement_badge: {
    paid: 'Wypłacony udział w przychodach: {{amount}}',
    other: 'Wypłata udziału w przychodach {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Wypłaty udziału w przychodach',
    retry: 'Ponów',
    toasts: {
      load_error: 'Nie udało się załadować wypłat.',
      retry_error: 'Ponowna próba nie powiodła się — spróbuj ponownie.',
      retry_paid: 'Udział w przychodach wypłacony.',
      retry_attempted: 'Ponowiono próbę — wypłata jeszcze nie przeszła, sprawdź jej status.',
    },
    columns: {
      period: 'Okres',
      amount: 'Kwota',
      status: 'Status',
      transfer: 'Przelew',
      paid_at: 'Zapłacono',
      payout: 'Wypłata',
    },
    payout: {
      direct: '{{amount}}, bez przeliczenia',
      direct_tooltip:
        'Kwota {{owed}}, przeliczona po kursie 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} i wysłana bez zmian: bez konwersji Stripe, bez opłaty.',
      converted: 'Wysłano {{sent}} → otrzymano {{arrived}}',
      expected: 'Wysłano {{sent}} → oczekiwano {{arrived}}',
      fee: 'Opłata za przeliczenie Stripe {{amount}}',
      net: 'netto {{amount}}',
      pending_details: 'Opłata i kwota netto pojawią się po rozliczeniu przelewu przez Stripe.',
      tooltip:
        'Do zapłaty {{owed}}. Przeliczono po kursie 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, wysłano z salda platformy w {{source_currency}}, a Stripe przeliczył po kursie 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe potrąca {{fee_rate}}% przy wpływie środków.',
    },
    statuses: {
      pending: 'Oczekująca',
      held: 'Wstrzymane',
      processing: 'W trakcie',
      paid: 'Wypłacono',
      failed: 'Nieudana',
      reversed: 'Zwrócone',
    },
    hold_reasons: {
      kyc_incomplete: 'Partner nie ukończył jeszcze weryfikacji konta wypłat.',
      transfers_inactive: 'Konto wypłat nie może jeszcze odbierać przelewów.',
      insufficient_platform_balance: 'Saldo platformy nie pokrywa obecnie tej wypłaty.',
      manual_hold: 'Wstrzymane ręcznie.',
      missing_fx_rate: 'Brak zapisanego kursu wymiany dla waluty wypłaty. Zostanie ponowione automatycznie.',
      unsupported_payout_currency:
        'Stripe nie może wypłacić tej kwoty na konto wypłaty w jego walucie z salda platformy.',
      amount_too_small: 'Kwota należna jest niższa niż minimalny przelew Stripe dla tej waluty.',
    },
  },
};
